// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import { AuthProvider } from './contexts/AuthContext';
import HomePage from './components/Home/Home';
import HowItWorksPage from './components/HowItWorks/HowItWorks';
import RandomPalette from './components/RandomPalette/RandomPalette';
import VisualizerPage from './pages/VisualizerPage';
import AccountPage from './pages/AccountPage';
import LoginPage from './pages/LoginPage';
import ProtectedRoute from './components/Account/ProtectedRoute';
import PaintDatabase from './components/PaintDatabase/PaintDatabase';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="app">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/how-it-works" element={<HowItWorksPage />} />
            <Route path="/random-palette" element={<RandomPalette />} />
            <Route path="/paints" element={<PaintDatabase />} />
            <Route path="/visualizer" element={<VisualizerPage />} />
            <Route
              path="/account"
              element={(
                <ProtectedRoute>
                  <AccountPage />
                </ProtectedRoute>
              )}
            />
            <Route path="/callback" element={<VisualizerPage />} />
            <Route path="/login" element={<LoginPage />} />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;